import SimpleBar from "simplebar";

export function simplebar() {
  const targets = document.querySelectorAll("[data-simplebar]");

  targets.forEach((el) => {
    // Two-step safety: 未初期化だけ初期化
    if (!SimpleBar.instances.get(el)) {
      new SimpleBar(el);
    }
  });
}